module.exports = __webpack_public_path__ + "static/a-xx-002-art-160fc827f4616191a495954788c36e49.jpg";